<template lang="pug">
extends ../../../../prototype/src/pug/layout/section_column_gray
include ../../../../prototype/src/pug/abstracts/mixin.pug
block main
	include ../../../../prototype/src/pug/abstracts/variables
	.markdown.escolha_modelo__text_block
		h2 Escolha a melhor opção de Certificado para você:

	ul.escolha_modelo__items
		+opcao_item('icon_escolha_modelo_1.svg', 'e-CPF', 'É o seu CPF digital, <strong>para Pessoa Física.</strong>', 'Comprar agora', "https://loja.spcbrasil.org.br/certificadopf")
		+opcao_item('icon_escolha_modelo_2.svg', 'e-CNPJ', 'É a identidade digital da sua empresa, <strong>para Pessoa Jurídica.</strong>', 'Comprar agora', "https://loja.spcbrasil.org.br/certificadopj")
	
mixin opcao_item(icon, title, description, cta, url)
	.escolha_modelo__item__wrapper
		.escolha_modelo__item__inner
			.escolha_modelo__body
				.escolha_modelo__icon
					+i(icon)
				h3.escolha_modelo__title= title
				.escolha_modelo__description !{description}
			.escolha_modelo__footer
				.escolha_modelo__cta
					a(href=url).button.button__no_right_margin= cta
</template>

<script>
export default {
	name: "ComprarComponent",
};
</script>
